import { ProfileMutations } from '@src/api/services/profile';
import ProfileService from './service';
import { GetManageAccessUserResponseData } from './types';

// @TODO: Refactor fetchUserProfile at later tech debt
export const getUserProfile = async () => await ProfileMutations.getUserProfile();

export const PROFILE_QUERY_KEYS = {
  GET_USER_BASIC_INFO: 'GET_USER_BASIC_INFO',
};

export class ProfileQueries {
  public static readonly getManageAccessUser = async (email: string): Promise<GetManageAccessUserResponseData> => {
    const data = await ProfileService.getManageAccessUser(email);
    return data;
  };
}
